import { EdgeLoadEffectiveHuntConstraintsRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadEffectiveHuntConstraints } from '@/shared/domain'

export function makeLoadEffectiveHuntConstraints(): LoadEffectiveHuntConstraints {
  return new EdgeLoadEffectiveHuntConstraintsRepository(makeSupabaseEdgeHttpClient()).execute
}
